import types from './types';

export default (
	state = {
		defaultLanguage: ''
	},
	{
		type,

		/** takeQuery REQUEST action will provide this */
		params,

		/** takeQuery REQUEST_SUCCESS or REQUEST_FAILURE actions wil provide these */
		request /* using takeQuery: the initier action is set here */,
		response /* using takeQuery: query result will be set here */,
		data,

		/* other actions */
		...action
	}
) => {
	switch (type) {
		case types.GET_DEFAULT_LANGUAGE:
			return { ...state };
		case types.GET_DEFAULT_LANGUAGE_SUCCESS:
			return { ...state, defaultLanguage: data };
		case types.GET_DEFAULT_LANGUAGE_FAILURE:
			return { ...state };
		default:
			return state;
	}
};
